import type { ThemeConfig } from 'antd';

/** Colours the shell and its stylesheet (`resource.css`) share. */
export const seewardColors = {
  primary: '#1677ff',
  border: '#e5eaf1',
  background: '#f7f9fc',
  text: '#24334a'
} as const;

export const seewardFontFamily =
  'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';

/** The one antd `ConfigProvider` theme for the app shell. */
export const seewardTheme: ThemeConfig = {
  token: {
    colorPrimary: seewardColors.primary,
    borderRadius: 6,
    fontSize: 13,
    fontFamily: seewardFontFamily
  }
};
